// Translations
import form from '../sections/form/translations/ar'

// Translation: Terms of service > Landing (Arabic)
export default Object.freeze({
	sections: { form }
})
